import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { WBSButton } from '@/common/WBSButton';

export const Route = createFileRoute('/_app/newsletter')({
  component: NewsletterRoute,
  beforeLoad: () => {
    return {
      pageBackground: 'white',
    };
  },
});

function NewsletterRoute() {
  const { t } = useTranslation();
  const handleUnsubscribe = () => {
    // TODO: Add actual API call to unsubscribe
  };

  return (
    <Container>
      {/* Translation Needed */}
      <Header>Newsletter</Header>
      {/* Translation Needed */}
      <Text>
        You are subscribed to our newsletter. Click the button to unsubscribe.
      </Text>
      <WBSButton wide onClick={handleUnsubscribe}>
        {t('wbs.unsubscribe-2')}
      </WBSButton>
    </Container>
  );
}

const Container = styled.div`
  padding: 27px 5px;
`;

const Header = styled.h1`
  color: var(--black);
  font-family: var(--raleway);
  font-size: 27px;
  font-weight: 600;
  letter-spacing: 0.5px;
  margin: 0 0 33px 0;
`;

const Text = styled.p`
  color: var(--grey-700);
  font-family: var(--raleway);
  font-size: 16px;
  line-height: 1.5;
  margin: 0 0 23px 0;
`;
